export const FETCH_DATA = 'FETCH_DATA'
export const UPDATE_QUERY_STRING = 'UPDATE_QUERY_STRING'

export const FETCH_COCKTAIL_ID = 'FETCH_COCKTAIL_ID'
export const UPDATE_COCKTAIL_ID = 'UPDATE_COCKTAIL_ID'
